export default {

    coffeeData: {
        windBreaker: "Wind Breaker Tree",
        horticultureInfo: "Horticulture Tree",
        shadeTree: "Shade Tree",
        coffeeVariety: "Coffee Variety",
        coffeeSpecies: "Coffee Species",
        updateWindBreaker: "Update windBreaker Tree Type",
        addWindBreaker: "Add New windBreaker Tree Type",
        updateHorticultureInfo: "Update horticultureInfo Tree Type",
        addHorticultureInfo: "Add New horticultureInfo Tree Type",
        updateShadeTree: "Update shadeTree Tree Type",
        addShadeTree: "Add New shadeTree Tree Type",
        updateCoffeeVariety: "Update coffeeVariety Tree Type",
        addCoffeeVariety: "Add New coffeeVariety Tree Type",
        deleteVarietyTitle: "Delete Variety",
        deleteVarietyMessage: "Are you sure you want to delete Variety?",
        updateCoffeeSpecie: "Update Coffee Specie",
        deleteSpecieTitle: "Delete Specie",
        deleteSpecieMessage: "Are you sure you want to delete Specie?",
        addCoffeeSpecie: "Add New Coffee variety",
        variety: "Variety",
        selectVariety: "Select Specie",
        deleteCoffeeRecord: "Are you sure you want to delete record?",
        deleteCoffeeData: "Delete Coffee Data",
        topicRequired: "Select Topic is required",
        coffeeAddSuccess: "Coffee Specie added successfully.",
        treeTypeSuccess: "Tree type added successfully.",
        treeTypeUpdateSuccess: "Tree type updated successfully.",
        coffeeVarietySuccess: "Coffee variety added successfully.",
        coffeeSpecieSuccess: "Coffee specie updated successfully.",
        nameRequired: "Name is required",
        notFound: "No Admin Coffee data Found",
      },
      cacaoData: {
        cacao: "Cacao",
        cacaoVariety: "Cacao Variety",
        cacaoSpecies: "Cacao Species",
        cacaoWeight: "Cacao Weight",
        cacaoOverview: "Cacao Overview",
        "buysellOverview": "Buy/Sell Overview",
        cacaoType: "Cacao Type",
        deleteCacaoData: "Delete Cacao Data",
        productWeight: "Product Weight",
        productType: "Type of Product",
        productPricePerKg: "Price per KG",
        registerFermentation: "Register Fermentation",
        batchVisualIdentification: "Batch Visual Indentification",
        initialWeight: "Initial Weight",
        finalWeight: "Final Weight",
        performance: "Performance",
        fermentationPercentage: "Fermentation Percentage",
        fermetationMethod: "Fermentation Method",
        boxes: "Boxes",
        piles: "Piles",
        bags: "Bags",
        selectZone: "Select Zone",
        selectPlantation: "Select Plantation",
        deliveryMethod: "Delivery Method",
        totalPrice: "Total Price",
      },

  

  memberDataSection: {
    import: "Import",
    buyingStation: "Buying Station",
    continue: "Continue",
    farmerId: "Farmer ID",
    farmerName: "Farmer Name",
    farmerAddress: "Farmer Address",
    quality: "Quality",
    quantity: "Quantity",
    importAll: "Import All",
    importSelected: "Import Selected",
    fileLoaded: "File loaded successfully",
    incorrectHeaders: "Incorrect headers",
    processingBatch: "Processing Batch",
    purchaseOrder: "Purchase Order",
    startDate: "Start Date",
    endDate: "End Date",
    purchasingOrder: "Purchasing Order",
    totalCoffeeCherry: "Total Coffee Cherry",
    airHumidity: "Air Humidity",
    density: "Density",
    temperature: "Temperature",
    beanMoistureContent: "Bean Moisture Content",
    processType: "Process Type",
    batchRating: "Select Rating Of The Batch",
    purchaseDate: "Purchase Date",
    selectFarmer: "Select Farmer",
    selectFarmers: "Select Farmers",
    selectFarm: "Select Farm",
    selectCrop: "Select Crop",
    selectPlantation: "Select Plantation",
    coffeeVariety: "Coffee Variety",
    coffeeSpecies: "Coffee Species",
    coffeeCherryQuantity: "Coffee Cherry Quantity",
    coffeeCherryQuality: "Coffee Cherry Quality",
    coffeeType: "Type of Coffee",
    pricePerKg: "Price Per Kg",
    processingDone: "Processing Done",
    processedCoffeeOut: "Processed Coffee Out",
    farmer: "Farmer",
    farm: "Farm",
    plantation: "Plantation",

    // Lately added
    farmers: "Farmers",
    farmLimitUsed: "Farm Limit Used",
    phoneNumber: "Phone Number",
    farmSize: "Farm Size",
    farmLocation: "Farm/Location",
    date: "Date",
    status: "Status",
    noFarmers: "No Farmers Found",
    approveReject: "Approve/Reject",
    farms: "Farms",
    crops: "Crops",
    equipment: "Equipment",
    noFarms: "No Farms Found",
    views: "View",
    selectStatus: "Select Status",
    approved: "Approved",
    rejected: "Rejected",
    reject: "Reject",
    approve: "Approve",
    cancel: "Cancel",
    add: "Add",
    describeYourReason: "Describe your reason here",
    userInformation: "User Information",
    userFarmRequest: "User Farm Request",
    userFarmInformation: "User Farm(s) Information",
    activity: "Activity",
    activityType: "Activity Type",
    farmZone: "Farm Zone",
    farmerView: "Farmer View",
    cropType: "Crop Type",
    cropVarity: "Crop Varity",
    area: "Area",
    cost: "Cost",
    geofence: "Geofence",
    map_views: "Map View",
    viewAllFarms: "View All Farms",
    farmersDetails: "Farmer Details",
    download: "Download",
    pOrder: {
      addNew: "Add New",
      viewAll: "View All",
      selectDate: "Select date",
      makeSelection: "Make a selection",
      coffeeType: "Type coffee quantity",
      enterPrice: "Enter Price",
      reqPurchaseDate: "Purchase date is required",
      reqFarmer: "Farmer is required",
      reqCoffeeQnty: "Coffee Cherry Quantity is required",
      reqPrice: "Price Per Kg is required",
      grandTotal: "GRAND TOTAL",
      selectDateRange: "Select Date Range",
      import: "Import",
      purchaseId: "Purchase Id",
      purchaseDate: "Purchase Date",
      farmerName: "Farmer Name",
      quality: "Quality",
      quantity: "Quantity",
      pricePerKg: "Price Per Kg",
      selectBuyingStation: "Select buying station",
      searchUser: "Search Users",
      purchaseListView: "Purchase List View",
      viewBy: "View by",
      typeDensity: "Type Density",
      typeTemperature: "Type temperature",
      typeWaterContent: "Type water content",
    },
    farmActivity: "Farm Activity",
    showOnMap: "Show On Map",
    farmInformation: "Farm Information",
    dateOfEntry: "Date Of Entry",
    farmID: "Farm ID",
    ownershipType: "Ownership Type",
    locationAddress: "Location Addresss",
    goalType: "Goal Type",
    totalSize: "Total Size",
    zones: "Zones",
    farmActivities: "Farm Activites",
    farmDetails: "Farm Details",
    totalFarmsRegistered: "Total Farms Registered",
    totalFarmArea: "Total Farm Area",
    totalZone: "Total Zone",
    zone: "Zone",

    totalCost: "Total Cost",
    selectFarmZone: "Select Zone/Farm",
    productionType: "Production Type",
    certifications: "Certifications",
    geofences: "Geofences",
    farmsChart: "Farms Chart",
  },
}